/**
 * Podporované datové typy atributů TEAF frameworku. Pro lepší typovou kontrolu se napříč aplikací využívá tento výčtový typ namísto stringových hodnot.
 * @includeToDoc
 */
export enum OWDataType {
    bcd = "BCD",
    binary = "Binary",
    boolean = "Boolean",
    byte = "Byte",
    color = "Color",
    date = "Date",
    dateTime = "DateTime",
    decimal = "Decimal",
    document = "Document",
    double = "Double",
    enum = "Enum",
    flags = "Flags",
    htmlText = "HtmlText",
    icon = "Icon",
    int64 = "Int64",
    integer = "Integer",
    localizedText = "LocalizedText",
    money = "Money",
    OWObject = "OWObject",
    OWObjectList = "OWObjectList",
    short = "Short",
    single = "Single",
    string = "String",
    strNum = "StrNum",
    text = "Text",
    time = "Time",
    timeSpan = "TimeSpan",
}
